package it.neckar.lizergy.model.financial.quote.query

import it.neckar.lizergy.model.financial.quote.QuoteElement
import it.neckar.open.collections.fastForEach

/**
 * Describes a query for relevance categories.
 * The query can be used to calculate sums.
 */
sealed interface Query {
  /**
   * Returns true if the given quote element matches this query
   */
  fun matches(quoteElement: QuoteElement): Boolean
}


sealed interface UnionQuery : Query {
  val delegates: List<Query>
}

/**
 * Returns true if all the delegates returns true.
 * Returns false if any of the delegates returns false.
 */
sealed interface AndQuery : UnionQuery {
  override fun matches(quoteElement: QuoteElement): Boolean {
    delegates.fastForEach { if (it.matches(quoteElement).not()) return false }
    return true
  }
}

/**
 * Returns true if all the delegates return false.
 * Returns false if at least one of the delegates returns true
 */
sealed interface NoneQuery : UnionQuery {
  override fun matches(quoteElement: QuoteElement): Boolean {
    delegates.fastForEach { if (it.matches(quoteElement)) return false }
    return true
  }
}
